// A staff invitation link (FR-41, FR-42) may be opened while signed out. The
// token waits in sessionStorage for this tab only, so sign-in (or sign-up then
// sign-in) can come back to /invitations/accept and finish joining.
const INVITATION_KEY = "invitation";

export const ACCEPT_INVITATION_PATH = "/invitations/accept";

export function saveInvitation(token: string) {
  try {
    sessionStorage.setItem(INVITATION_KEY, token);
  } catch {
    /* storage unavailable: the token lives only in the link */
  }
}

export function pendingInvitation(): string | null {
  try {
    return sessionStorage.getItem(INVITATION_KEY);
  } catch {
    return null;
  }
}

export function clearInvitation() {
  try {
    sessionStorage.removeItem(INVITATION_KEY);
  } catch {
    /* ignore */
  }
}

/** safeNext accepts only a same-origin path, so a crafted link cannot redirect elsewhere. */
export function safeNext(next: string | null): string | null {
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return null;
  return next;
}

/** afterSignIn is where a successful sign-in goes: the requested page, a pending invitation, or the account. */
export function afterSignIn(next: string | null): string {
  return safeNext(next) ?? (pendingInvitation() ? ACCEPT_INVITATION_PATH : "/account");
}
